/* eslint-disable no-mixed-spaces-and-tabs */
// ----------------------------------------------------------------------
// <copyright file="Izenda.GroupRadioInput.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * GroupRadioInput Component
 */
!(function() {
  var React = require('react');

  var GroupRadioInput = React.createClass({

  	propTypes: {
      onChange: React.PropTypes.func.isRequired,
			options: React.PropTypes.oneOfType([
        React.PropTypes.object.isRequired,
        React.PropTypes.array.isRequired
      ]),
			value: React.PropTypes.string
    },

    /**
     * Handle when one option click
     * @param  {object} e React event
     * @return 
     */
  	handleValueChange: function(e) {
  	  this.props.onChange && this.props.onChange({value: e.target.value});
    },

    /**
     * Render group of of radio base on input value
     */
    render: function() {

      var selectedValue = this.props.value || this.props.options[0].value;

      var options = this.props.options.map(function(item, index) {
        return (
          <div key={index}>
            <input  type='radio'
                    value={item.value}
                    checked={item.value === selectedValue}
                    onChange={this.handleValueChange}/>
            <span title={item.label}> {item.label} </span>
          </div>
        );
      }.bind(this));

      return (
        <div>
          {options}
        </div>
      );

    }
  });

  module.exports = GroupRadioInput;

}());



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.GroupRadioInput.jsx